import type { CommandHandler } from '../types';

export const createTaskForTeamCommandHandler: CommandHandler = (command, context) => {
  const projectId = Number(context.parentId ?? context.entityId);
  if (!Number.isInteger(projectId) || projectId <= 0) {
    return {
      success: false,
      error: 'Open a saved project first.',
    };
  }

  if (!context.openCreateTaskForTeamDialog) {
    return {
      success: false,
      error: 'Create task dialog is not available.',
    };
  }

  context.openCreateTaskForTeamDialog(command, projectId);
  return { success: true };
};
